import { render, staticRenderFns } from "./ListagemClub.vue?vue&type=template&id=6c900b2f&scoped=true"
import script from "./ListagemClub.vue?vue&type=script&lang=js"
export * from "./ListagemClub.vue?vue&type=script&lang=js"
import style0 from "./ListagemClub.vue?vue&type=style&index=0&id=6c900b2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c900b2f",
  null
  
)

export default component.exports